import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { createCalendarBlockRoute, eventsKey } from '@features/enterpriseEvents';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type UseCreateInterviewBlockProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreateInterviewBlock = ({
  setErrorText = () => { },
}: UseCreateInterviewBlockProps) => {
  const client = useQueryClient();

  const { mutate: createInterviewBlock, isLoading: isCreatingInterviewBlock } =
    useMutation({
      mutationFn: (variables: {
        start_time: number;
        end_time: number;
        eventDate: string;
        max_spots: number;
        job_ids?: string;
        company_id?: number

      }) =>
        axiosInstance
          .post(createCalendarBlockRoute, variables)
          .then((res) => res.data),
      onSuccess: (data, req) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries([eventsKey]);
          client.invalidateQueries([profileKey]);
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    createInterviewBlock,
    isCreatingInterviewBlock,
  };
};
